import { get, Response } from 'modules/api';
import { GetCredentialsResponse } from './types';
import { URL } from './consts';

export const getCredentialsRequest = (): Promise<
  Response<GetCredentialsResponse>
> => get(URL.GET_MESSAGE_BROKER_CREDENTIALS);
